import styled from "styled-components"

export const BVATabsContainer = styled.div`
  
`